import {gql} from 'apollo-boost';

export const GET_CLASSASSIGNMENT = gql`
  query getClassAssignment($id : ID!){
    getClassAssignment (
      id: $id
    ) {
      id
      sectionNo topicLocal topicEng
      descriptionLocal descriptionEng
      score dueDate uploadPath uploadPathUri uploadFileName
      sequence active
      classSection {
        id sectionNo
      }
    }
  }
`;

export const GET_CLASSASSIGNMENTS_BY_FILTER = gql`

  query getClassAssignmentsByFilter($classAssignmentFilterInput: ClassAssignmentFilterInput){
    getClassAssignmentsByFilter (
      classAssignmentFilterInput:$classAssignmentFilterInput
    ){
      id
      sectionNo topicLocal topicEng
      descriptionLocal descriptionEng
      score dueDate uploadPath uploadPathUri uploadFileName
      sequence active
      classSection {
        id sectionNo
      }

    }
  }
`;

export const GET_CLASSASSIGNMENTS = gql`
  query getClassAssignments {
    getClassAssignments {
      id
      sectionNo topicLocal topicEng
      descriptionLocal descriptionEng
      score dueDate uploadPath uploadPathUri uploadFileName
      sequence active
      classSection {
        id sectionNo
      }
    }
  }
`;

export const CHECK_CAN_DELETE = gql`
  query checkCanDelete($id : ID!){
    checkCanDelete (
      id: $id
    ) {
      id
    }
  }
`;

export const ADD_CLASSASSIGNMENT = gql`
  mutation addClassAssignment(
    $classSectionId: ID!
    $classAssignmentInput: ClassAssignmentInput!
  ) {
    addClassAssignment(
      classSectionId: $classSectionId
      classAssignmentInput: $classAssignmentInput
    ) {
      id
      sectionNo topicLocal topicEng
      descriptionLocal descriptionEng
      score dueDate uploadPath uploadPathUri uploadFileName
      sequence active
      classSection {
        id sectionNo
      }
    }
  }
`;

export const UPDATE_CLASSASSIGNMENT = gql`
  mutation updateClassAssignment(
    $id: ID!,
    $classAssignmentInput: ClassAssignmentInput!
  ) {
    updateClassAssignment(
      id: $id
      classAssignmentInput: $classAssignmentInput
    ) {
      id
      sectionNo topicLocal topicEng
      descriptionLocal descriptionEng
      score dueDate uploadPath uploadPathUri uploadFileName
      sequence active
      classSection {
        id sectionNo
      }
    }
  }
`;

export const DELETE_CLASSASSIGNMENT = gql`
  mutation deleteClassAssignment($id: ID!) {
    deleteClassAssignment(
      id: $id
    ) {
      id
      sectionNo topicLocal topicEng
      descriptionLocal descriptionEng
      score dueDate uploadPath uploadPathUri uploadFileName
      sequence active
      classSection {
        id sectionNo
      }
    }
  }
`;

